import { Button } from "@/components/ui/button"
import { useNapForm } from "../NapFormContext"
import { LookupItem } from "@/types/activity"
import { Sun, Moon } from "lucide-react"

interface EnvironmentStepProps {
  environments: LookupItem[]
  childName?: string
  onNext: () => void
  onPrev?: () => void
}

export function EnvironmentStep({ environments, childName, onNext, onPrev }: EnvironmentStepProps) {
  // Access form through context
  const form = useNapForm();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-center text-blue-300 mb-5">
        What was the sleeping environment like?
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
        {environments.map((environment) => (
          <Button
            key={environment.id}
            type="button"
            variant={form.watch("environment_id") === environment.id ? "default" : "outline"}
            className={`w-full py-3 px-4 h-auto text-left justify-start whitespace-normal transition-all duration-200 ${
              form.watch("environment_id") === environment.id 
                ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-md" 
                : "bg-slate-800 border-slate-600 text-slate-300 hover:bg-slate-700 hover:text-white"
            }`}
            onClick={() => {
              form.setValue("environment_id", environment.id)
              form.clearErrors("environment_id")
              onNext()
            }}
          >
            {environment.name?.toLowerCase().includes('dark') ? (
              <Moon className={`mr-2 h-4 w-4 shrink-0 ${form.watch("environment_id") === environment.id ? "text-blue-200" : "text-blue-400"}`} />
            ) : (
              <Sun className={`mr-2 h-4 w-4 shrink-0 ${form.watch("environment_id") === environment.id ? "text-yellow-200" : "text-yellow-400"}`} />
            )}
            <span className="text-sm line-clamp-2">{environment.name || environment.description || environment.id}</span>
          </Button>
        ))}
      </div>
      
      {form.formState.errors.environment_id && (
        <p className="text-sm text-red-400 bg-red-900/20 p-2 rounded border border-red-800/30 mt-2">
          {form.formState.errors.environment_id.message}
        </p>
      )}
      
      <div className="flex justify-between pt-4">
        {onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-slate-600 bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white"
          >
            Back
          </Button>
        )}
        
        <Button
          type="button"
          onClick={() => onNext()}
          className="ml-auto bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white shadow-md"
        >
          Skip
        </Button>
      </div>
    </div>
  )
}